export function eventSelectionChange(event, setSelectedEvents) {
    setSelectedEvents(event?.selection);
    return false;
}